import { CommonModule } from "@angular/common";
import { Component, Inject, OnInit } from "@angular/core";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatTableModule } from "@angular/material/table";
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { TreasuryRateModel } from "../../models/treasury-rate.model";
import { ILoggedInUser } from "../../../interfaces/common/loggedInUser";
import { LoggedInUserService } from "../../../services/common/logged-in-user.service";
import { TreasuryRateService } from "../../services/treasury-rate.service";
import { Months } from "../../../shared/models/months.model";
import { ManageTreasuryRateModel } from "../../models/manage-treasury-rate.model";

@Component({
  selector: "app-manage-treasury-rate",
  templateUrl: "./manage-treasury-rate.component.html",  
  standalone: true,  
  imports: [CommonModule, MatTableModule, MatProgressSpinnerModule, MatPaginatorModule, ReactiveFormsModule],
})
export class ManageTreasuryRateComponent implements OnInit {
  isLoading: boolean = false;
  user: ILoggedInUser;
  isAdmin: boolean = false;
  searchDone: boolean = false;
  treasuryRate: TreasuryRateModel
  months = [];
  title: string  = "";
  buttonName: string = "";
  form: FormGroup;
  information: string = "";
  confirmation: string = "Confirm that you want to remove this exchange rate entry.";

  constructor(    
    @Inject(MAT_DIALOG_DATA) public id: number,    
    public dialogRef: MatDialogRef<ManageTreasuryRateComponent>,
    private userService: LoggedInUserService,
    private fb: FormBuilder,
    private treasuryRateService: TreasuryRateService
  ) {}

  ngOnInit(): void {
    if(this.id > 0){
      this.buttonName = "Update";
      this.title = "Edit Treasury Rate";
    } else {
      this.buttonName = "Add";
      this.title = "New Treasury Rate";
    }

    this.months = Object.values(Months).filter(value => typeof value === 'string') as string[];
    
    this.form = this.fb.group({
      exchangeRate: new FormControl(''),
      year: new FormControl(''),
      month: new FormControl(''),
    });

    this.userService.currentUser$.subscribe(data => {
      this.user = data;
      if(this.user != null && this.user.adminRight){
        this.isAdmin = this.user.adminRight;
        this.getTreasuryRate();
      }      
    });
  }

  getTreasuryRate(){    
    if(this.id > 0){
      this.treasuryRateService.getTreasuryRate(this.id).subscribe(data => { 
        this.treasuryRate = data;
        this.form.patchValue(data);   
        this.setMonth();
      });
    }
  }

  setMonth() {
    this.form.get('month').setValue(Months[this.treasuryRate.month]);
  }

  getformValues(): ManageTreasuryRateModel{
    return {
      currId: this.id,
      exchangeRate: this.form.get('exchangeRate').value,
      year: this.form.get('year').value,
      month: Months[this.form.get('month').value as keyof typeof Months],
      userEmail: this.user.userEmail,
      userName: this.user.userName
    };
  }

  tryDelete(){
    if(confirm("Confirm that you want to remove this exchange rate entry.")) {
      this.delete();
    }
  }

  delete(){
    if(this.id > 0){
      this.treasuryRateService.deleteTreasuryRate(this.getformValues()).subscribe({
        next: (result) => {
          if (result.isSuccess) {
            this.information = "Treasury rate entry deleted.";
          } else {
            this.information = result.error.description;
          }
        },
        error: (err) => {
          console.error('Error deleting treasury rate entry: ', err);
          this.information = 'Could not delete treasury rate entry.';
        }
      });
    }
  }

  startAction(){
    if(this.id > 0){      
      this.treasuryRateService.updateTreasuryRate(this.getformValues()).subscribe({
        next: (result) => {
          if (result.isSuccess) {
            this.information = "Treasury rate Updated";
          } else {
            this.information = result.error.description;
          }
        },
        error: (err) => {
          console.error('Error updating treasury rate entry: ', err);
          this.information = 'Could not change treasury rate entry.';
        }
      });

    }
    else{
      this.treasuryRateService.addTreasuryRate(this.getformValues()).subscribe({
        next: (result) => {
          if (result.isSuccess) {
        this.information = "Treasury rate entry added.";
          } else {
        this.information = result.error.description;
          }
        },
        error: (err) => {
          console.error('Error adding treasury rate entry: ', err);
          this.information = 'Could not add treasury rate entry.';
        }
      });
    }
  }
  
  close() {
    this.dialogRef.close();
  }
}
